import {
  DEMANDE_INTERVENTION_TYPE,
  DEMANDE_IMPRESSION_TYPE,
  DISPOSITIF_A_FABRIQUER,
  DISPOSITIF_EN_COURS_FABRICATION,
  DISPOSITIF_FABRICATION_TERMINEE,
  PAO_BACHE_COMMANDEES,
  PAO_MAQUETTES_VALIDES,
  IMPRESSIONS_TERMINEES,
  DISPOSITIF_EXPEDIE,
  DISPOSTIF_A_FACTURER,
  DISPOSITIF_A_POSER,
} from '@/configuration/logistique/suiviProduction/suiviProductionConfig';
import { ETAT_REALISE, ETAT_A_EXPEDIER, ETAT_EXPEDIE } from '@/configuration/logistique/ordreTravail/ordreTravailConf';
import { ETAT_NOUVEAU } from '@/configuration/logistique/intervention/interventionConf';
import { FABRICATION_DISPOSITIF, DISPOSITIF_FABRIQUE } from '@/configuration/logistique/typeOt/typeOtConfig';

const IMPRESSIONS_TERMINEES_ETAT_OT = [
  ETAT_REALISE,
  ETAT_A_EXPEDIER,
  ETAT_EXPEDIE,
];

export default {
  [DISPOSITIF_A_FABRIQUER]: (demande) => {
    return demande.etat === ETAT_NOUVEAU
      && demande.type === DEMANDE_INTERVENTION_TYPE
      && demande.typeOt?.actionInterventionOt === FABRICATION_DISPOSITIF;
  },
  [DISPOSITIF_EN_COURS_FABRICATION]: (demande) => {
    return demande.type === DEMANDE_INTERVENTION_TYPE
    && demande.typeOt?.actionInterventionOt === FABRICATION_DISPOSITIF
    && !!demande.ot
    && demande.ot?.otEtat !== ETAT_REALISE;
  },
  [DISPOSITIF_FABRICATION_TERMINEE]: (demande) => {
    return demande.type === DEMANDE_INTERVENTION_TYPE
    && demande.typeOt?.actionInterventionOt === FABRICATION_DISPOSITIF
    && demande.ot?.otEtat === ETAT_REALISE;
  },
  [PAO_BACHE_COMMANDEES]: (demande) => {
    return demande.type === DEMANDE_IMPRESSION_TYPE && !demande.ot;
  },
  [PAO_MAQUETTES_VALIDES]: (demande) => {
    return demande.type === DEMANDE_IMPRESSION_TYPE
    && demande.ot
    && !IMPRESSIONS_TERMINEES_ETAT_OT.includes(demande.ot?.otEtat);
  },
  [IMPRESSIONS_TERMINEES]: (demande) => {
    return demande.type === DEMANDE_IMPRESSION_TYPE
    && demande.ot
    && IMPRESSIONS_TERMINEES_ETAT_OT.includes(demande.ot?.otEtat);
  },
  [DISPOSITIF_A_POSER]: (demande) => {
    return demande.type === DEMANDE_INTERVENTION_TYPE
    && demande.typeOt?.actionInterventionOt === DISPOSITIF_FABRIQUE
    && !!demande.ot
    && demande.ot?.otEtat === ETAT_A_EXPEDIER;
  },
  [DISPOSITIF_EXPEDIE]: (demande) => {
    return demande.type === DEMANDE_INTERVENTION_TYPE
    && demande.typeOt?.actionInterventionOt === DISPOSITIF_FABRIQUE
    && demande.ot?.otEtat === ETAT_EXPEDIE;
  },
  [DISPOSTIF_A_FACTURER]: (demande) => {
    return demande.type === DEMANDE_INTERVENTION_TYPE
    && demande.typeOt?.actionInterventionOt === DISPOSITIF_FABRIQUE
    && demande.ot?.otEtat === ETAT_REALISE;
  },
};
